export enum AnalyticsCallEvent {
  CallJoinedGuest = 'call_joined_guest',
}
